
import * as React from "react"
import { useMediaQuery } from "@/hooks/use-media-query"
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogDescription,
} from "@/components/ui/dialog"
import {
    Drawer,
    DrawerContent,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
    DrawerDescription,
} from "@/components/ui/drawer"

interface ResponsiveModalProps {
    children: React.ReactNode
    trigger?: React.ReactNode
    title?: React.ReactNode
    description?: React.ReactNode
    open?: boolean
    onOpenChange?: (open: boolean) => void
}

export function ResponsiveModal({
    children,
    trigger,
    title,
    description,
    open,
    onOpenChange
}: ResponsiveModalProps) {
    const isDesktop = useMediaQuery("(min-width: 768px)")

    if (isDesktop) {
        return (
            <Dialog open={open} onOpenChange={onOpenChange}>
                {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
                <DialogContent className="sm:max-w-xl">
                    <DialogHeader className={!title ? "p-0" : ""}>
                        <DialogTitle className={!title ? "sr-only" : ""}>
                            {title || "Modal"}
                        </DialogTitle>
                        {description && <DialogDescription>{description}</DialogDescription>}
                    </DialogHeader>
                    {children}
                </DialogContent>
            </Dialog>
        )
    }

    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            {trigger && <DrawerTrigger asChild>{trigger}</DrawerTrigger>}
            <DrawerContent>
                <DrawerHeader className={`text-left ${!title ? "p-0" : ""}`}>
                    <DrawerTitle className={!title ? "sr-only" : ""}>
                        {title || "Modal"}
                    </DrawerTitle>
                    {description && <DrawerDescription>{description}</DrawerDescription>}
                </DrawerHeader>
                <div className="pb-4 pt-2 overflow-y-auto max-h-[70vh] px-4">
                    {children}
                </div>
            </DrawerContent>
        </Drawer>
    )
}
